import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';

import { PaymentGatewaySettingsPage } from './payment-gateway-settings.page';

const routes: Routes = [
  {
    path: '',
    component: PaymentGatewaySettingsPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild(routes)
  ],
  declarations: [PaymentGatewaySettingsPage]
})
export class PaymentGatewaySettingsPageModule {}
